<template>
  <div class="tab" v-ps>
    <div
      v-for="tab in tabList"
      v-show="show(tab)"
      :key="tab.value"
      :class="['tab-item', { selected: tab.value === currentTab }]"
      @click="changeTab(tab)"
    >
      <span class="tab-title">
        <slot :tab="tab">
          {{ tab.label }}
        </slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: {
    tabList: {
      type: Array,
      default: () => [
        // { label: "标签页", value: "标签页" },
        // { label: "签页", value: "签页" },
        // { label: "页", value: "页" }
      ]
    },
    defaultActive: String,
    viewVisible: Array
  },
  watch: {
    defaultActive(val) {
      this.currentTab = val
    }
  },
  data() {
    return {
      currentTab: this.defaultActive
    }
  },
  methods: {
    changeTab(tab) {
      if (!tab) return
      this.currentTab = tab.value
      this.$emit("input", tab.value)
      this.$emit("click", tab.value)
    },
    show(tab) {
      if (!this.viewVisible) return true
      return !this.viewVisible.includes(tab.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  line-height: 20px;
  position: relative;
  .tab-item {
    flex-shrink: 0;
    height: 30px;
    display: flex;
    flex-flow: column;
    cursor: pointer;
    color: #535c65;
    user-select: none;
    .tab-title {
      padding: 0 10px 6px 10px;
      font-size: $font-size-main;
    }
    &.selected {
      .tab-title {
        color: $color-main;
        height: 26px;
        box-sizing: border-box;
      }
      &::after {
        content: "";
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background: $color-main;
        /*position: absolute;*/
      }
    }
  }
}
</style>
